// extracted by mini-css-extract-plugin
export default {"explanationContainer":"Option_explanationContainer__Zi7SZ","explanation":"Option_explanation__HFotl","sendButton":"Option_sendButton__waEsr","header":"Option_header__dw-GC"};